// Parse month from DD/MM/YY or DD/MM/YYYY string format
// Extract the number between first / and second / and convert to YYYY-MM
export const parseMonth = (dateStr) => {
    if (!dateStr) return null;
    
    // Convert to string
    dateStr = String(dateStr).trim();
    
    // Skip NA or empty
    if (dateStr === 'NA' || dateStr === '' || dateStr === '-') return null;
    
    // Handle Excel serial number (if somehow still a number)
    if (typeof dateStr === 'number' || !isNaN(dateStr)) {
      const num = parseFloat(dateStr);
      if (num > 40000) { // Excel serial dates start from 1900
        const excelEpoch = new Date(1899, 11, 30);
        const date = new Date(excelEpoch.getTime() + num * 86400000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
      }
    }
    
    // DD/MM/YY or DD/MM/YYYY format
    const parts = dateStr.split('/');
    
    if (parts.length === 3) {
      // Get the month number (between first / and second /)
      const monthNum = parseInt(parts[1], 10);
      
      // Get the year
      let year = parts[2].trim();
      if (year.length === 2) {
        const yearNum = parseInt(year, 10);
        year = yearNum >= 50 ? `19${year}` : `20${year}`;
      }
      
      // Format as YYYY-MM
      const month = String(monthNum).padStart(2, '0');
      return `${year}-${month}`;
    }
    
    return null;
  };
  
  // Subtract months from a YYYY-MM string
  const subtractMonth = (monthKey, monthsToSubtract) => {
    if (!monthKey) return null;
    const [year, month] = monthKey.split('-').map(Number);
    const date = new Date(year, month - 1); // month is 0-indexed in Date
    date.setMonth(date.getMonth() - monthsToSubtract);
    
    const newYear = date.getFullYear();
    const newMonth = String(date.getMonth() + 1).padStart(2, '0');
    return `${newYear}-${newMonth}`;
  };
  
  // Detect CM, CM-1, CM-2 from data
  export const detectMonths = (data, dateField) => {
    const monthKeys = new Set();
    
    data.forEach(row => {
      const monthKey = parseMonth(row[dateField]);
      if (monthKey) {
        monthKeys.add(monthKey);
      }
    });
    
    // Find the latest month (CM)
    const sorted = Array.from(monthKeys).sort().reverse();
    const CM = sorted[0] || null;
    
    // Calculate CM-1 and CM-2 by subtracting months
    const CM1 = CM ? subtractMonth(CM, 1) : null;
    const CM2 = CM ? subtractMonth(CM, 2) : null;
    
    return {
      CM,
      CM1,
      CM2,
    };
  };
  
  // Filter data by month
  export const filterDataByMonth = (data, dateField, monthKey) => {
    return data.filter(row => {
      const rowMonth = parseMonth(row[dateField]);
      return rowMonth === monthKey;
    });
  };
  
  // Parse a date string (DD/MM/YY or DD/MM/YYYY) and return a Date object
  export const parseDateString = (dateStr) => {
    if (!dateStr) return null;
    
    // Convert to string
    dateStr = String(dateStr).trim();
    
    // Skip NA, empty, or placeholder
    if (dateStr === 'NA' || dateStr === '' || dateStr === '-') return null;
    
    // Handle Excel serial number
    if (typeof dateStr === 'number' || !isNaN(dateStr)) {
      const num = parseFloat(dateStr);
      if (num > 40000) {
        const excelEpoch = new Date(1899, 11, 30);
        return new Date(excelEpoch.getTime() + num * 86400000);
      }
    }
    
    // DD/MM/YY or DD/MM/YYYY format
    const parts = dateStr.split('/');
    
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // 0-indexed
      let year = parts[2].trim();
      
      if (year.length === 2) {
        const yearNum = parseInt(year, 10);
        year = yearNum >= 50 ? 1900 + yearNum : 2000 + yearNum;
      } else {
        year = parseInt(year, 10);
      }
      
      return new Date(year, month, day);
    }
    
    return null;
  };
  
  // Calculate days difference between two dates
  export const daysDifference = (date1, date2) => {
    if (!date1 || !date2) return null;
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  